import React from 'react'
import FormDialog from '../../../../library/form/components/FormDialog';
import withView from '../../../cmn/docAutomation/withView';
import FormInput from '../../../../library/form/components/FormInput';
import FormCheckbox from '../../../../library/form/components/FormCheckbox';
import FormLabel from '../../../../library/form/components/FormLabel';
import FormRichText from '../../../../library/form/components/FormRichText';
import FormTitle from '../../../../library/form/components/FormTitle';
import FormWrapper from '../../../../library/form/components/FormWrapper';
import { UiGridColTwo, UiCol, UiRow } from "../../../../library/layout/Index";

const ItemPriceEditor = (props) => {
    const { formObject, viewData, ...restProps } = props;

    if(!viewData)
        return(null)
        
    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true}
            action={{ formActions: { forAction: "Confirm", forCancel: "Cancel" } }}
            contentStyle={{ height: '350px', width: '650px',overflowY:'scroll'}}
            formTitle={<FormTitle formObject={formObject} value='Item Price' />}
            formObject={formObject} >
            <UiGridColTwo>
                <UiCol>
                    <ul>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "priceType" }} value="Price Type" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput"
                                action={{ InputType: "ac", paramName: "priceType", acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' } }}
                            />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "itemPrice1" }} value="Value" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className=""
                                action={{ InputType: "input", paramName: "itemPrice1" }}
                            />
                        </li>
                        <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "itemPrice2" }} >
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "itemPrice2" }} value="Value 2" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className=""
                                action={{ InputType: "input", paramName: "itemPrice2" }}
                            />
                        </FormWrapper>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "priceUnit" }} value="Unit" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput"
                                action={{ InputType: "ac", paramName: "priceUnit", acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' } }}
                            />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "priceCurrency" }} value="Currency" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className=" "
                                action={{ InputType: "ac", paramName: "priceCurrency", acMethod: "CurrencyName" }}
                            />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "includesTax" }} value="Includes Tax" />
                            </span>
                            <FormCheckbox formObject={formObject} rowKey='' className=""
                                action={{ InputType: "onOff", paramName: "includesTax"}}
                            />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "needInteraction" }} value="Request Price" />
                            </span>
                            <FormCheckbox formObject={formObject} rowKey='' className=""
                                action={{ InputType: "onOff",  paramName: "needInteraction" }}
                            />
                        </li>
                    </ul>
                </UiCol>
                <UiCol>
                    <ul>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "location" }} value="Location" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput"
                                action={{ InputType: "ac", paramName: "location", acMethod: "Location" }}
                            />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "locationGroup" }} value="Location Group" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className=""
                                action={{ InputType: "input", paramName: "locationGroup" }}
                            />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "tagTypeId" }} value="Tag Type Id" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className=""
                                action={{ InputType: "ac", paramName: "tagTypeId", acMethod: "Category" }}
                            />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "tagId" }} value="Tag Id" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className=""
                                action={{ InputType: "ac", paramName: "tagId", acMethod: "CategoryDetail", acDepCtrl: { dparam: '#tagTypeId' } }}
                            />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "isActive" }} value="Is Active" />
                            </span>
                            <FormCheckbox formObject={formObject} rowKey='' 
                                action={{ InputType: "onOff", paramName: "isActive" }}
                            />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "isBasePrice" }} value="Is Base Price" />
                            </span>
                            <FormCheckbox formObject={formObject} rowKey='' className=""
                                action={{ InputType: "onOff", paramName: "isBasePrice"}}
                            />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "isVolatile" }} value="Mark Volatile" />
                            </span>
                            <FormCheckbox formObject={formObject} rowKey='' className=""
                                action={{ InputType: "onOff",  paramName: "isVolatile" }}
                            />
                        </li>
                    </ul>
                </UiCol>
            </UiGridColTwo>
            <UiRow>
                <span className="uiLbl">
                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "comments" }} value="Remarks" />
                </span>
                <FormRichText formObject={formObject} rowKey="" className="" rows="2" cols="82" maxlength="1000"
                    action={{ paramName: "comments" }}
                />
            </UiRow>
        </FormDialog>
    )
}
 
export default withView(ItemPriceEditor, "itemPrice", "itemPrice")